import React from 'react';
import Header from './Header';
import Navigation from './Navigation';
import NewPostButton from './NewPostButton';

const NavBar: React.FC<{ showNewPostButton?: boolean }> = ({ showNewPostButton }) => (
  <div className='fixed top-0 right-0 left-0 z-20 flex flex-col items-center self-stretch text-sm lg:mx-20 xl:mx-48 2xl:mx-96'>
    <Header />
    <Navigation />
    {showNewPostButton && <NewPostButton />}
  </div>
);

export default NavBar;
